var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.66 1.38a1.48 1.48 0 0 1 .35 1 15.22 15.22 0 0 1-2.14 7.91 15.22 15.22 0 0 1-5.59 5.59A15.38 15.38 0 0 1 2.37 18a1.48 1.48 0 0 1-1-.35 1.72 1.72 0 0 1-.56-.88l-.76-3.33a1.59 1.59 0 0 1 .12-1.09 1.46 1.46 0 0 1 .83-.73l3.55-1.55a1.49 1.49 0 0 1 1-.07 1.69 1.69 0 0 1 .88.56L7.57 12A10.72 10.72 0 0 0 12 7.57l-1.44-1.12a1.69 1.69 0 0 1-.56-.88 1.49 1.49 0 0 1 .07-1L11.62 1a1.46 1.46 0 0 1 .73-.83 1.59 1.59 0 0 1 1.09-.12l3.34.77a1.72 1.72 0 0 1 .88.56zM9.44 14.43a14.2 14.2 0 0 0 5-5 13.66 13.66 0 0 0 1.9-7l-3.2-.74-1.49 3.49L14 7.12a14.05 14.05 0 0 1-2.76 4.18A14.51 14.51 0 0 1 7.12 14l-1.94-2.35-3.48 1.48.74 3.2a13.66 13.66 0 0 0 7-1.9z"}));
}

Phone.defaultProps = {"viewBox":"0 0 18.01 18.01"};

module.exports = Phone;

Phone.default = Phone;
